const sorts = [
    {
       
        name: "Accio",
        text: "Attirer quelque chose",
      
        
    },
    {
      
        name: "Allohomora",
        text: "Ouvrir une porte verouillé",
    },
    {
       
        name: "Amplificatum",
        text: "Grossir un objet",
    }
    ,
    {
       
        name: "Avada kedavra",
        text: "Tuer quelqu'un (sort interdit)",
    }
    ,
    {
        
        name: "Collaporta",
        text: "Sceller une porte",
    }
    ,
    {
       
        name: "Crac badaboum",
        text: "Casser un objet",
    },
    {

        name: "Crache limace",
        text: "Faire cracher des limaces",
    },
    {

        name: "Croque cheville",
        text: "Attacher les chevilles ensemble",
    },
    {

        name: "Destructum",
        text: "Detruire quelque chose",
    },
    {

        name: "Diffinito",
        text: "Couper quelque chose",
    },
    {

        name: "Dissensium",
        text: "Ouvrir un passage secret",
    },
    {

        name: "Ectoplasmus",
        text: "Decoller quelque chose",
    },
    {

        name: "Elasticus",
        text: "Sauter très haut",
    },
    {

        name: "Endoloris",
        text: "Faire très mal",
    },
    {

        name: "Enervatum",
        text: "Enerver quelqu'un",
    },
    {

        name: "Evanesco",
        text: "Fair disparaitre quelque",
    },
    {

        name: "Expelliarmus",
        text: "Renvoyer quel que chose ou Faire ejecter une ou plusieures baguettes magiques",
    },
    {

        name: "Failamal",
        text: "Ranger des affaires dans une male",
    },
    {

        name: "Fera verta",
        text: "Transformer un animal en verre à vin",
    },
    {

        name: "Finit",
        text: "Arreter un sort",
    },
    {

        name: "Flambois",
        text: "Faire un signe en feu",
    },
    {

        name: "Flipendo",
        text: "Petrifier quelqu'un pendant ",
    },
    {

        name: "Impédimenta",
        text: "Fair tomber quelqu'un",
    },
    {

        name: "Imperium",
        text: "Se faire obérir par quelqu'un",
    },
    {

        name: "Incarcerem",
        text: "Se faire obérir par quelqu'un",
    },
    {

        name: "Incendio",
        text: "Casser une plante",
    },
    {

        name: "Imobilis",
        text: "Imobiliser quelqu'un",
    },
    {

        name: "Légilimens",
        text: "Penetrer dans l'esprit d'un humain",
    },
    {

        name: "Locomotor barda",
        text: "Lever et fair avancer un objet ou quelqu'un à quelques centimètres du sol",
    },
    {

        name: "Lumos",
        text: "Illuminer au bout de sa baguette",
    },
    {

        name: "Lumus solem",
        text: "Illuminer une pièce",
    },
    {

        name: "Mobilicorpus",
        text: "Neutraliser un sort d' imobilisation",
    },

];

export default sorts
